export default __webpack_public_path__ + "static/media/mountain.8c2cc1d6.svg";